(ns machtfit.startpage.api-events
  (:require [machtfit.api :as api]
            [machtfit.startpage.clock :as clock]
            [machtfit.startpage.emarsys :as emarsys]
            [medley.core :refer [map-vals]]
            [re-frame.core :as rf]))

(defn startpage-data-loaded? [db]
  (-> db :articles some?))

(defn- add-post [fx request]
  (update fx :fx (fnil conj []) [:post request]))

(rf/reg-event-fx
  ::load-optional-api-data
  (fn [{:keys [db]} [_ optional-api-data]]
    {:post (api/request db
                        {:data optional-api-data
                         :on-success #(rf/dispatch [::api-received %])})}))

(defn load-data-on-demand
  ([{:keys [db] :as fx}]
   (let [page-id (-> db :ui :page :id)
         startpage-data-required? (#{:catalog
                                     :stepchall} page-id)
         want-startpage-data? (and startpage-data-required?
                                   (-> db startpage-data-loaded? not)
                                   (not (:startpage-data-requested? db)))
         fetch-emarsys-campaigns? (and (-> db :user :authenticated?)
                                       (-> db :fetch-emarsys-campaigns?)
                                       (nil? (-> db :emarsys-campaigns))
                                       (not (:emarsys-campaigns-requested? db)))
         api-data (cond-> []
                    want-startpage-data? (into '[(:articles {} :articles)
                                                 (:slider {} :slider)
                                                 (:server-info {} :server-info)]))
         optional-api-data (cond-> []
                             fetch-emarsys-campaigns? (into '[(:emarsys-campaigns {} :emarsys-campaigns)]))]
     (cond-> fx
       (seq api-data) (-> (assoc-in [:db :startpage-data-requested?] true)
                          (add-post (api/request db
                                                 {:data api-data
                                                  :on-success #(rf/dispatch [::api-received %])})))
       (seq optional-api-data) (-> (assoc-in [:db :emarsys-campaigns-requested?] true)
                                   (assoc :dispatch-later [{:dispatch [::load-optional-api-data optional-api-data]
                                                            :ms 3000}]))))))

(defn- by-id [data]
  (->> data
       (group-by :id)
       (map-vals first)))

(defn- api->fx [fx {{{articles :result} :articles
                     {emarsys-campaigns :result} :emarsys-campaigns
                     {favorites :result} :favorites
                     {stepchall :result} :stepchall-state
                     {server-info :result} :server-info
                     {slider :result} :slider} :result}]
  (cond-> fx
    (some? articles) (assoc-in [:db :articles] (by-id articles))
    (some? emarsys-campaigns) (assoc-in [:db :emarsys-campaigns] (emarsys/load-campaigns emarsys-campaigns))
    (some? stepchall) (assoc-in [:db :stepchall] stepchall)
    (some? server-info) (-> (assoc-in [:db :server-info] server-info)
                            (update :db clock/update-server-time (:reference-now server-info)))
    (some? slider) (assoc-in [:db :slider] slider)
    (some? favorites) (assoc-in [:db :user :favorites] (->> favorites (map :id) set))))

(rf/reg-event-fx ::api-received
  (fn [{:keys [db]} [_ result]]
    (-> {:db db}
        (api->fx result)
        load-data-on-demand)))

(defn- need-all-participants? [db]
  (and (= (-> db :ui :page :subpage) :leaderboard)
       (-> db :ui :stepchall :leaderboard :scope (= :participants))
       (not= (-> db :stepchall :loaded-participants) :all)))

(defn- need-team-participants? [db]
  (let [subpage (-> db :ui :page :subpage)
        loaded-participants (-> db :stepchall :loaded-participants)
        team-id (-> db :ui :page :team-id)]
    (or (= subpage :join-team)
        (not (contains? #{:all team-id} loaded-participants)))))

(defn- empty-stepchall? [db]
  (-> db :stepchall nil?))

(defn api-requests-on-stepchall-event [{:keys [db] :as fx}]
  (let [team-id (-> db :ui :page :team-id)
        stepchall-state-parameters {:participants (cond
                                                    (need-all-participants? db) :all
                                                    (need-team-participants? db) team-id)}
        api-data (when (or (empty-stepchall? db)
                           (some? (:participants stepchall-state-parameters)))
                   `[(:stepchall-state ~stepchall-state-parameters :stepchall-state)])]
    (cond-> fx
      api-data (add-post (api/request
                          db
                          {:data api-data
                           :on-success #(rf/dispatch [::api-received %])})))))
